<template>
	<div class="d-flex align-items-center justify-content-center mt-3 mb-3 pagination-loading">
		Loading more results...
	</div>
</template>

<script>
export default {
	name: 'PaginationLoading',
}
</script>
